
/// <summary>
/// Generates a javascript-based tree menu <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 19.10.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 19.10.2022                                              *<br />
/// **********************************************************************<br />
/// * - refactored into jquery widget from vcTreeMenu                    *<br />
/// **********************************************************************<br />
/// </summary>

$.widget("bluaul.vcTreeMenu2",
    {
 
       defaultOptions: {
        vcgid: '0000',
        h: 500, w: 250, showErrors: false, showAllAtStart: false, showNotAssigned: true, showTickets: true, data: null,
        clearFilter: false, callback: function () { }
    },

        _create: function() {},

        _init: function () {
            var me = this;
            try {

              
                me.selected = { id: -1, name: '', subNames: null };
                me.options = $.extend({}, me.defaultOptions, me.options);

                if (me.element.hasClass("vc-tree-menu") === false) { me.element.addClass("vc-tree-menu"); }

                if (me._validateData() === false) {
                    me.options.callback({ "type": "error", "value": "invalid data" });
                    return null;
                }
                me.element.html("");
                me._generateMainMenu();

            } catch (e) { me._writeError(e); }
        },

        _validateData: function () {
            /// <summary>
            /// Helper functions for validating the incoming menu data
            /// </summary>
            var me = this;
            try {
                if (me.options.data == null) { return false; }
                if (me.options.data.rows === null) { return false; }
                if (me.options.data.rows.length === 0) { return false; }
                return true;
            } catch (ex) { me._writeError(ex); return false }
        },

        _generateMainMenu: function () {
               /// <summary>
            /// builds the first hierarchy of entries
            /// </summary>
            var me = this;
            try {
            if (me.options.clearFilter) {
                me.selected.id = -1;
                me.selected.name = "";
            }
              
            //set the currently selected menu item based on the given settings
            if (me.selected.id === -1) {
                if (me.options.showAllAtStart === false) {
                    me.selected.id = me.options.data.rows[0].id;
                    me.selected.name = me.options.data.rows[0].name;
                } else {
                    me.selected.id = -1;
                    me.selected.name = "";
                }
            }

            ////expand the html structure
            me._expand();
            //generate the main list and set the first data item as selelcted
            //$.fn.vcTreeMenu.obj.html("<div id='caption'>Hauptmenü</div>");
            me.element.append(me._getMenuList(-1, -1, me.selected.id));

            //refill previously selected subnames 
            if (me.selected.subNames !== null) {
                me.element.find(".selected .vc-tree-menu-subnames").html(me.selected.subNames);
            }

            //add a hardcoded 'all signals' item at the end of the list
            me._addStaticAllSignalsItem();
            //init click handler
            me._initClickHandler();
            //send an init event with the name of the first data item for the initial data filtering
                me.options.callback({ "type": "init", "value": me.selected.name });
            } catch (e) { me._writeError(e); }
        },

        _getMenuList: function (parent, level, selected) {
            /// <summary>
            /// Generates one menu list based on the given parent tag and level
            /// </summary>
            var me = this;
           
            var found = false;
            var hasChilds;
            var icon, span, fa, li;
            try {
                var data = me.options.data;
                var ul = $("<ul>").data("id", parent).data("level", level + 1).css("max-height", me.options.h - 10);
                if (level > -1) {
                    ul.addClass("vc-grid-2col");
                }

                //mark the list as main if it has level -1
                if (level === -1) { ul.addClass("vc-tree-menu-main"); }
                //iterate all data items and find all for the given parent id
                for (var i = 0; i < data.rows.length; i++) {

                    if (data.rows[i].parentid === parent) {

                        li = $("<li>").data("id", data.rows[i].id).data("parent", data.rows[i].parentid)
                            .data("level", level + 1).addClass("vc-tree-menu-item vc-grid-2col");
                        //mark list item as selected
                        if (data.rows[i].id === selected) {
                            li.addClass("selected");
                        }
                        //find out if the item has any childs
                        //if so, add the expander icon
                        hasChilds = false;

                       
                        for (var j = 0; j < data.rows.length; j++) {

                          
                            if (data.rows[j].parentid === data.rows[i].id) {
                                li.addClass("vc-tree-menu-item-sub");
                                span = $("<span>");
                                fa = $("<i/>");
                                fa.addClass("vc-tree-menu-expander fa");
                                if (data.rows[i].id === selected) {
                                    fa.addClass("fa-minus-square");
                                } else {
                                    fa.addClass("fa-plus-square");
                                }

                                fa.appendTo(span);
                                span.appendTo(li);
                                hasChilds = true;
                                j = data.rows.length;
                            }
                        }
                      
                        //get the tag type icon
                        icon = me._getIcon(data.rows[i].typeid);
                    
                        li.append(icon +" <span class='vc-tree-menu-name'>" + data.rows[i].name + "</span>");

                        if (me.options.showErrors) {
                            li.append("<span class='vc-tree-menu-errors'></span>");
                        }
                       
                     

                        //if the icon has any childs, add an empty div for selected sub items later on
                        if (hasChilds) li.append("<div class='vc-tree-menu-subnames'></div>");
                      
                        li.appendTo(ul);
                       
                        found = true;
                    }

                }

                if (found) {
                    return ul;
                } else {
                    return null;
                }
            } catch (ex) { me._writeError(ex); return null }
        },

        _addStaticAllSignalsItem: function () {
            /// <summary>
            /// Adds optional menu entries at the begining or end of the menu
            /// </summary>
            // menu point - 'show all'
            var me = this;
            try {

              
            var li = $("<li>").data("id", -999).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item vc-tree-menu-item-all").html("<i class='fa fa-signal' /> " + window._RESOURCES.JS_Com.showAll_lbl.toUpperCase() + " <span class='vc-tree-menu-name'></span>");

                if (me.selected.id === -999 & me.selected.name === "") { li.addClass("selected"); }

                if (me.options.showErrors) { li.append("<span class='vc-tree-menu-errors'></span>"); }

                if (me.options.showAllAtStart && me.selected.id === -1) { li.addClass("selected"); }
                li.prependTo(me.element.find(".vc-tree-menu-main"));

                // menu point - 'no assigned tags'
                if (me.options.showTickets) {
                    li = $("<li>").data("id", -888).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item").html(
                        "<i class='fa-regular fa-ticket' />  " + "Tickets" +
                        " <span class='vc-tree-menu-name' style='display:none'>has_ticket</span>");
                    if (me.options.showErrors) {
                        li.append("<span class='vc-tree-menu-errors'></span>");
                    }
                    if (me.selected.id === -888 & me.selected.name === "has_ticket") {
                        li.addClass("selected");
                    }
                    li.appendTo(me.element.find(".vc-tree-menu-main"));
                }
                if (me.options.showNotAssigned) {
                    li = $("<li>").data("id", -999).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item").html("<i class='fa fa-question' />  " + window._RESOURCES.JS_Com.withoutTags_lbl +
                        " <span class='vc-tree-menu-name' style='display:none'>no_assigned_tags</span>");
                    if (me.options.showErrors) { li.append("<span class='vc-tree-menu-errors'></span>"); }
                    if (me.selected.id === -999 & me.selected.name === "no_assigned_tags") { li.addClass("selected"); }
                    li.appendTo(me.element.find(".vc-tree-menu-main"));
                }

            } catch (ex) { me._writeError(ex); return null }
        },

        _initClickHandler: function () {
            var me = this;
            try {
            var list;
          
        
            me.element.off("click", ".vc-tree-menu-item").on("click", ".vc-tree-menu-item", function (e) {
                try {

                    var level = parseInt($(this).data("level"), 10);
                    //remove all lists which are not valid anymore
                    me._removeLists(level);
                    //remove the selected level from all already possibly selected items
                    me._clearItems(level);
                    $(this).addClass("selected");

                    me._selectItem($(this), level);
                    e.stopPropagation();
                } catch (ex) { me._writeError(ex); }
            });
            me.element.off("click", ".vc-tree-menu-expander").on("click", ".vc-tree-menu-expander", function (e) {
                try {
                    var item = $(this).parents(".vc-tree-menu-item");
                    var level = parseInt(item.data("level"), 10);

                  
                    //remove all lists which are not valid anymore
                    me._removeLists(level);
                 
                    if ($(this).hasClass(".fa-minus-square")) {

                        me._unselectCurrentItem(item);
                    } else {

                        if (item.find(".vc-tree-menu-subnames").html().length === 0) {
                            //remove the selected class from all possibly selected items
                            me._clearItems(level);
                            item.addClass("selected");
                            list = me._getMenuList(item.data("id"), level, -1);
                            me.element.find(".vc-tree-menu-overlay").append(list).show();
                          
                        } else {
                            //rebuild the previously selected items
                          
                            me._reOpenSubLists(item);

                            me.element.find(".vc-tree-menu-overlay").show();
                        }

                        $(this).removeClass("fa-plus-square").addClass("fa-minus-square");


                        me.setErrors(me.options.errorTags);
                    }


                    e.stopPropagation();
                } catch (ex) { me._writeError(ex); }
            });

            } catch (ex) { me._writeError(ex); return null }
        },

        _getIcon: function (typeid) {
            switch (typeid) {
                case 2: return "<i class='fa-regular fa-star' />";
                case 3: return "<i class='fa fa-signal' />";
                case 4: return "<i class='fa fa-magic' />";
                case 5: return "<i class='fa-regular fa-tag' />";
                case 6: return "<i class='fa-regular fa-tag' />";
                case 7: return "<i class='fa-regular fa-tag' />";
                case 8: return "<i class='fa fa-lock' />";
                case 9: return "<i class='fa fa-cog' />";
                default: return "";
            }
        },

        _expand: function () {
            /// <summary>
            /// Handles the expanding on one menu entry which contains submenu entries 
            /// </summary>
            var me = this;
            try {

                var main = $("<div>").appendTo(me.element);
                $("<div>").addClass("vc-tree-menu-overlay").appendTo(me.element);

                me.element.find(".vc-tree-menu-overlay").css("left", me.options.w);
                me.element.find(".vc-tree-menu-overlay").width($(window).width() - main.width() - 25);
                me.element.find(".vc-tree-menu-overlay").height($(window).height() - me.element.offset().top - 25);


              

            } catch (ex) { me._writeError(ex); }
        },

        _removeLists: function (level) {
            /// <summary>
            /// Removes all menu lists which are higher than the given level
            /// It is used to remove currently open submenus when clicking another menu point
            /// </summary>
            var me = this;
            try {
                me.element.find("ul").each(function () {
                    if (parseInt($(this).data("level"), 10) > level) {
                        $(this).remove();
                    }
                });
            } catch (ex) { me._writeError(ex); }
        },

        _unselectCurrentItem: function (item) {
            /// <summary>
            /// Removes all menu lists which are higher than the given level
            /// and changes the submenu icons 
            /// </summary>
            var me = this;
            try {


                if (item.find(".vc-tree-menu-subnames").length === 0) {
                    item.removeClass("selected");
                    item.find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                    if (me.elemen.find(".vc-tree-menu-overlay ul").length === 0) {
                        me.element.find(".vc-tree-menu-overlay").hide();
                    }
                } else {
                    me._reOpenSubLists(item);
                    if (me.element.find(".vc-tree-menu-overlay ul").length === 0) {
                        me.element.find(".vc-tree-menu-overlay").hide();
                    }
                }

            } catch (ex) { me._writeError(ex); }
        },

        _reOpenSubLists: function (item) {
            /// <summary>
            /// Is used to expand all submenus for a currently selected menu point
            /// It iterates all subnames of the menu point and rebuilds all sub menus
            /// </summary>
            var me = this;
            try {
                var level = 0;
                item.find(".vc-tree-menu-subnames div").each(function () {

                    var list = me._getMenuList($(this).data("parent"), level, $(this).data("id"));
                    me.element.find(".vc-tree-menu-overlay").append(list).show();
                    level++;
                });
               

                //find the last item - if it has an expander - close the expander icon 
                me.element.find(".vc-tree-menu-overlay li.selected").last().find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");


               
            } catch (ex) { me._writeError(ex); }
        },

        _clearItems: function (level) {
            /// <summary>
            /// Removes the selected class from all possibly selected items
            /// </summary>
            var me = this;
            try {
                me.element.find("li").each(function () {
                    if (parseInt($(this).data("level"), 10) >= level) {
                        $(this).removeClass("selected");
                        $(this).find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                        $(this).find(".vc-tree-menu-subnames").html("");
                    }
                });
            } catch (ex) { me._writeError(ex); }
        },

        _selectItem: function (item, level) {
            /// <summary>
            /// If an menu item got selected it sets the name and id, sends a callback and ...
            /// if the menu is a submenu from another menu point it iterates all parents and builds the subname informations for the highest parent menu
            /// </summary>
            var me = this;
            try {
                var sSubNames = "";
                if (level > 0) {
                    me.element.find(".vc-tree-menu-overlay li.selected").each(function () {
                        sSubNames += "<div data-parent='" + $(this).data("parent") + "' data-id='" + $(this).data("id") +
                            "' style='margin-left:" +
                            (parseInt($(this).data("level"), 10) * 20) + "px'>" + $(this).find(".vc-tree-menu-name").html();
                        if (me.options.showErrors) {
                            sSubNames += "<span class='vc-tree-menu-subname'>" + $(this).find(".vc-tree-menu-name").html() + "</span><span class='vc-tree-menu-errors'>" + $(this).find(".vc-tree-menu-errors").html() + "</span>";
                        }
                        sSubNames += "</div>";
                    });
                }
                me.element.find(".vc-tree-menu-main li.selected .vc-tree-menu-subnames").html(sSubNames);
                me.element.find(".vc-tree-menu-main li.selected .vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                me.selected.id = parseInt(me.element.find(".vc-tree-menu-main li.selected").data("id"), 10);


                me.selected.name = item.find(".vc-tree-menu-name").html();

                me.selected.name = $("<div/>").html(me.selected.name).text();

                if (sSubNames === "") {
                    me.selected.subNames = null;
                } else {
                    me.selected.subNames = sSubNames;
                }
                me.element.find(".vc-tree-menu-overlay").hide();

                me.options.callback({ "type": "update", vcgid: me.options.vcgid, "value": me.selected.name });
                //''  }



            } catch (ex) { me._writeError(ex); }
        },

         setErrors: function (errorTags) {
            /// <summary>
            /// Removes all error infos and refills them
            /// </summary>
            var me = this;
            try {

                me.options.errorTags = errorTags;
                me.element.find(".vc-tree-menu-errors").html("");
                me._setErrorTags(errorTags, ".vc-tree-menu-name");
                me._setErrorTags(errorTags, ".vc-tree-menu-subname");

                return this;
           
            } catch(ex) { me._writeError(ex); }
        },

        _setErrorTags: function (tags, cssClass) {
            /// <summary>
            /// Takes the given parameter list and iterates all menu points
            /// The number of found tags in the parameter list - which is the same as the current menu point - gets written to the error div
            /// </summary>
         
            var menuEntry;
            var counter = 0;
            var me = this;
            try {
              
                me.element.find(cssClass).each(function () {
                    menuEntry = $(this).html();
                    if (menuEntry.indexOf("<span>") > -1) {
                        menuEntry = menuEntry.substring(0, menuEntry.indexOf("<span>")-1);
                    }
                    counter = jQuery.grep(tags, function (value) {
                        return value.indexOf(menuEntry) !== -1;
                    }).length;
                    if (counter === 0) {
                        $(this).next(".vc-tree-menu-errors").html("");
                    } else {
                        $(this).next(".vc-tree-menu-errors").html(counter);
                    }
                });
                return this;
            } catch (ex) { me._writeError(ex); return null }
        },

        _writeError: function (ex) {
            this.options.callback({ "type": "error", "value": ex });
        },

        //destroy: function () {
        //    this.element.removeClass("vc-tree-menu").html("");
        //    super.
        //}

    });

